import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from '../Section';
import { CTAButton } from '../CTAButton';
export function Guarantee() {
  return <Section tone="light" data-id="element-136" data-mp="20j8qe0t9fk4z">
      <div className="flex justify-center" data-id="element-137" data-mp="24mom8uxi9ggm">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-navy-950" data-id="element-138" data-mp="24lx1yg9cz55n">
          <ShieldCheckIcon className="h-10 w-10 text-gold-500" aria-hidden="true" data-id="element-139" data-mp="29fhuhss6n6xg" />
        </span>
      </div>

      <h2 className="mt-4 text-center font-display text-[28px] font-extrabold uppercase leading-[1.05] text-navy-950 sm:text-[40px]" data-id="element-140" data-mp="2jbulgiwcf6oi">
        Your purchase is protected by our 7-day guarantee
      </h2>

      <div className="mt-5 space-y-3 text-[15px] leading-relaxed text-navy-800 sm:text-lg" data-id="element-141" data-mp="2scj27ld4fl53">
        <p data-id="element-142" data-mp="txfya30z3rv4">
          Buying something online can feel risky. So we’ll take the risk instead
          of you.
        </p>
        <p data-id="element-143" data-mp="xxzyjfgufblh">
          Download Technical System PRO 360™, open the systems, explore the
          templates and see how everything can help you organize and
          professionalize your appliance repair business.
        </p>
        <p className="font-semibold text-navy-950" data-id="element-144" data-mp="3nt5c8kr6239j">
          Use it. Review it. Put it into practice.
        </p>
        <p data-id="element-145" data-mp="3itiwo4nv8axk">
          And if within the next 7 days you feel that the system doesn’t deliver
          what we promised, simply contact us. We’ll refund 100% of your
          purchase.
        </p>
      </div>

      <ul className="mt-5 grid gap-2 sm:grid-cols-3" data-id="element-146" data-mp="fck9vmt1i8fe">
        {['No complicated forms.', 'No phone calls.', 'No uncomfortable questions.'].map(item => <li key={item} className="rounded-lg border border-navy-950/10 bg-white px-3 py-3 text-center text-[13px] font-semibold text-navy-900 sm:text-sm" data-id="element-147" data-mp="5f5u7pexxno5">
              {item}
            </li>)}
      </ul>

      <div className="mt-8" data-id="element-148" data-mp="2l7lj8locevsh">
        <CTAButton icon="🛡️" label="Try Technical System PRO 360™ risk-free" data-id="element-149" data-mp="2l6bkrvdkvllb" />
      </div>
    </Section>;
}